module.exports = __webpack_public_path__ + "static/media/motes.4059fb28.jpg";